import React from 'react'
import Navbar from '../../Components/Navbar'
import ProdctHeader from '../../Components/ProdctHeader'
import IntroProduct from '../../Components/IntroProduct'
import Business from '../../Components/Business'
import Footer from '../../Components/Footer'

const ProductFocus = () => {
  return (
    <div>
   <Navbar/>
   <ProdctHeader/>
   <IntroProduct/>
   <Business/>
   <Footer/>
      
    </div>
  )
}

export default ProductFocus
